import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import zibitLogoLight from '../images/zibit-logo-light.svg';
import zibitLogoDark from '../images/zibit-logo-dark.svg';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Pages that have a dark hero — nav starts transparent
  const darkHeroPaths = ['/', '/solutions', '/resources', '/about', '/careers', '/contact'];
  const hasDarkHero = darkHeroPaths.includes(location.pathname);

  useEffect(() => {
    // If we're on a page without a dark hero, always show solid nav
    if (!hasDarkHero) {
      setScrolled(true);
      return;
    }

    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    // Reset on page change
    setScrolled(window.scrollY > 80);

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasDarkHero, location.pathname]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : 'navbar--transparent'}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/">
            <img
              src={scrolled ? zibitLogoDark : zibitLogoLight}
              alt="Zibit"
              className="logo-img"
            />
          </Link>
        </div>

        <ul className="nav-menu">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/solutions">Solutions</Link></li>
          <li><Link to="/resources">Resources</Link></li>

          <li className="dropdown">
            <span className="dropdown-trigger">Company</span>
            <div className="dropdown-menu">
              <Link to="/about">About Us</Link>
              <Link to="/careers">Careers</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </li>
        </ul>

        <div className="nav-buttons">
          <Link to="/signup">
            <button className="nav-get-started">Get Started</button>
          </Link>
          <Link to="/login">
            <button className="nav-login">Login</button>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;